// Meta-detector pipeline card. Renders region-narrowing signals
// (driving side, road lines, vegetation, script, etc.) and the
// model's overall region guess derived from them.
//
// Doesn't drive final_guess synthesis — surfaces conflicting
// evidence so the human at the keyboard can spot when the pinpoint
// ensemble disagrees with the meta detector (e.g. Gemini guesses
// Brazil but meta says "Cyrillic + birch + RHD" → trust meta).

import { PipelineCard } from "./PipelineCard";
import type { CardState } from "../state/store";

export function MetaPipelineCard({ state }: { state: CardState }) {
  return (
    <PipelineCard pipeline="meta" state={state}>
      {state.status === "complete" && state.meta ? (
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <span className="font-semibold">{state.meta.region_guess}</span>
            <span className="ml-auto text-[10px] tabular-nums">
              conf {(state.meta.confidence * 100).toFixed(0)}%
            </span>
          </div>
          {state.meta.signals.length > 0 && (
            <div className="flex flex-col gap-0.5 text-[11px] text-fg-muted leading-snug">
              {state.meta.signals.slice(0, 6).map((s, i) => (
                <div key={i}>
                  <span className="font-medium text-fg">{s.type}:</span>{" "}
                  {s.value}
                  {s.implies && (
                    <span className="text-[10px]"> → {s.implies}</span>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      ) : null}
    </PipelineCard>
  );
}
